
/* injects from baggage-loader */

'use strict';

//import _ from 'lodash';

import { cards } from './main.const';

export default class MainController {
    constructor($log, $rootScope, $state, Session, Dialog) {
        'ngInject';
        this.$log = $log;
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.Session = Session;
        this.Dialog = Dialog;
        this.cards = cards;
    }

    goToPage(page){
        this.$state.go(page.route);
    }

    // $onInit(){
    //     this.$log.log("Hello, from main!");
    // }

    redirectToStages(){
        this.$state.go("page-four");
    }
}


// WEBPACK FOOTER //
// ./src/app/pages/main/main.controller.js